<template>
  <div>
    <SetPopup ref="confirm" />
    <v-form lazy-validation ref="form">
      <div class="filter-box filter-box--row">
        <ul class="filter-list_free">
          <li style="width: 120px">
            <h4>Lot No</h4>
            <v-text-field outlined dense placeholder="" v-model="input.lotNo" :rules="[this.validSet.commonCodeHipen]" @keyup.enter="search"></v-text-field>
          </li>
          <li style="width: 120px">
            <h4>Code Grade</h4>
            <v-text-field outlined dense placeholder="" v-model="input.code" :rules="[this.validSet.commonCodeHipen]" @keyup.enter="search"></v-text-field>
          </li>
          <li style="width: 120px">
            <h4>수령업체명</h4>
            <v-text-field outlined dense placeholder="" v-model="input.requestCompany" :rules="[this.validSet.company]" @keyup.enter="search"></v-text-field>
          </li>
          <li style="width: 120px">
            <h4>수령자</h4>
            <v-text-field outlined dense placeholder="" v-model="input.pickName" :rules="[this.validSet.name]" @keyup.enter="search"></v-text-field>
          </li>
          <li>
            <h4>발송일</h4>
            <div class="dp--row">
              <v-menu v-model="picker1" :close-on-content-click="false" :nudge-right="0" :nudge-top="20" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="input.fromSendDate" placeholder="" append-icon="mdi-calendar" outlined dense readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker no-title @input="picker1 = false" v-model="input.fromSendDate"></v-date-picker>
              </v-menu>
              <i class="ml-1 mr-1">~</i>
              <v-menu v-model="picker2" :close-on-content-click="false" :nudge-right="0" :nudge-top="20" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="input.toSendDate" placeholder="" append-icon="mdi-calendar" outlined dense readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker no-title @input="picker2 = false" v-model="input.toSendDate"></v-date-picker>
              </v-menu>
            </div>
          </li>
          <li style="width: 120px">
            <h4>발송상태</h4>
            <div class="wrapperTop">
              <v-select :items="sendStatusOptions" v-model="input.sendStatus" outlined id="sendStatus" />
            </div>
          </li>
        </ul>
        <div class="btn-box">
          <v-card-actions>
            <v-btn depressed outlined class="btn-reset" @click="reset">초기화</v-btn>
          </v-card-actions>
          <v-card-actions>
            <v-btn depressed class="btn-search" @click="search">검색</v-btn>
          </v-card-actions>
        </div>
      </div>
    </v-form>
    <!--    <h3 class="mt-2 mb-2 dp&#45;&#45;row">-->
    <!--      <v-btn depressed class="btn-download" @click="excelDownload" style="width: 143px; margin-left: auto">엑셀 다운로드</v-btn>-->
    <!--    </h3>-->
    <RealGrid :domName="grid" ref="grid" :settings="settings" @changePage="loadData" @click="click" />

    <!-- 메일 내용 보기 팝업 -->
    <v-dialog v-model="contentDialog" max-width="900px">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          메일 발송 내용
          <v-spacer></v-spacer>
          <v-btn icon @click="contentDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-4">
          <div v-html="selectedMailContent" class="mail-content-container"></div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="contentDialog = false">닫기</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import validSet from '@/assets/valid';
import RealGrid from '@/components/RealGrid.vue';
import SetPopup from '@/components/SetPopup.vue';
import { columns, fields } from '@/assets/grid/sendHistory';
import { sendHistoryList } from 'api/sample/sample';
import { getMailFolderZip } from 'api/file';
import _ from 'lodash';
import { mapMutations } from 'vuex';

export default {
  data() {
    return {
      isFetching: false,
      isDataLoaded: false,
      id: '',
      picker1: false,
      picker2: false,
      validSet,
      grid: 'sendHistory',
      contentDialog: false,
      selectedMailContent: '',
      input: {
        lotNo: '',
        code: '',
        requestCompany: '',
        pickName: '',
        pageSize: 100000,
        fromSendDate: '',
        toSendDate: '',
        sendStatus: '전체',
      },
      sendStatusOptions: ['전체', '성공', '실패', '지연'],
      origin: [],
      items: [],
      settings: {
        columns,
        fields,
        rows: 8,
        height: 650,
        errorMessage: '내역이 존재하지 않습니다',
        hideCheckBar: true,
      },
    };
  },
  watch: {
    param: {
      deep: true,
      handler: function () {
        this.currentPage = 1;
      },
    },
  },
  methods: {
    ...mapMutations('popup', ['SET_POPUP']),
    ...mapMutations('member', ['SET_USER_INFO']),
    valid() {
      return this.$refs.form.validate();
    },
    async excelDownload() {
      const idx = this.$refs.grid.getCheckedRowIdxRadio();
      if (idx !== undefined && !isNaN(idx)) {
        const row = this.items[idx];

        console.log('Excel download for row:', row);

        // TODO: 엑셀 다운로드 API 연동
        this.openPopup('엑셀 다운로드 기능은 백엔드 연동 후 구현됩니다', false);
      } else {
        this.openPopup('다운로드할 행을 선택해주세요', false);
      }
    },
    openPopup(text, closable, cb) {
      this.SET_POPUP({
        title: '알림',
        width: 300,
        text,
        closable,
      });
      this.$refs.confirm.openPopup(cb);
    },
    async search(v) {
      if (!this.valid()) return;
      if (this.isFetching) return;
      this.isFetching = true;

      try {
        if (_.isNumber(v)) {
          this.currentPage = v;
        }

        // API 파라미터 변환 (프론트 -> 백엔드)
        const params = {
          ...this.input,
          currentPage: this.currentPage,
          // 발송상태 변환
          sendStatus: this.input.sendStatus === '성공' ? 'CMP' : this.input.sendStatus === '실패' ? 'FLD' : this.input.sendStatus === '지연' ? 'DLY' : '',
        };

        const res = await sendHistoryList(params);
        this.isDataLoaded = false;

        const response = res.data;

        console.log(res.data, 'data');
        const items = response.data.items;
        this.items = response.data.items;
        const page = response.data.params;

        this.$refs.grid.loadData(items);
        this.$refs.grid.setPage(page);
      } catch (err) {
        console.error('Search error:', err);
        this.openPopup('데이터 조회 중 오류가 발생했습니다', false);
      } finally {
        this.isFetching = false;
      }
    },
    reset() {
      this.input = {
        lotNo: '',
        code: '',
        requestCompany: '',
        pickName: '',
        pageSize: 100000,
        fromSendDate: '',
        toSendDate: '',
        sendStatus: '전체',
      };
    },
    loadData(v) {
      this.search(v);
    },
    async click(data) {
      console.log(data, 'click data');
      if (data.cellType !== 'header') {
        try {
          const row = this.$refs.grid.getJsonRows();
          const rowData = row[data.itemIndex];
          const filePath = rowData.file_path;
          const mailContent = rowData.mail_content;

          if (data.fieldName === 'has_content' && mailContent) {
            this.selectedMailContent = mailContent;
            this.contentDialog = true;
          } else if (data.fieldName === 'has_file' && filePath) {
            console.log('Download folder zip:', filePath);
            const folderPath = filePath.endsWith('/') ? filePath : filePath + '/';
            await getMailFolderZip(folderPath);
          }
        } catch (error) {
          console.error('click processing error', error);
        }
      }
    },
    resizeGrid() {
      const totalHeight = window.innerHeight;
      const targetGrid = document.querySelector(`div#${this.grid}`);
      if (!targetGrid) return;
      let dynamicHeight = 360;
      if (this.showSearchOptions) {
        dynamicHeight += 70;
      }
      targetGrid.style.height = `${totalHeight - dynamicHeight}px`;
    },
  },
  mounted() {
    this.id = this.$store.state.member.userInfo.memberId;
    this.loadData();
    this.resizeGrid();
    window.addEventListener('resize', this.resizeGrid);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeGrid);
  },
  components: {
    RealGrid,
    SetPopup,
  },
};
</script>
<style lang="scss">
.mail-content-container {
  max-height: 600px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  padding: 15px;
  background-color: #fff;
}
</style>
